import { MifeParcel } from '@/components/MifeParcel';
import { useAuth } from '@/features/auth/store/authStore';
import { eventBus } from '@/libs/eventBus';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/_unauthenticated/(auth-routes)/signup/confirm')({
  component: () => <SignupConfirm />,
});

function SignupConfirm() {
  const signIn = useAuth.use.signIn();
  const navigate = useNavigate();

  useEffect(() => {
    eventBus.on('mife:login', (event) => {
      signIn(event.IdToken);
      navigate({ to: event.redirectTo });
    });

    return () =>
      eventBus.off('mife:login', (event) => {
        signIn(event.IdToken);
        navigate({ to: event.redirectTo });
      });
  }, [navigate, signIn]);

  return <MifeParcel />;
}
